// extracted by mini-css-extract-plugin
export var dividerLine = "_6l-3";
export var itemImage = "_6l-9";
export var lightDivider = "_6l-4";
export var modalContent = "_6l-5";
export var modalContentCompact = "_6l-6";
export var productCard = "_6l-a";
export var productImage = "_6l-b";
export var productImageCompact = "_6l-7";
export var productImagePlaceholder = "_6l-c";
export var productImagePlaceholderCompact = "_6l-8";
export var progressBarBackground = "_6l-1";
export var progressBarContainer = "_6l-0";
export var progressBarFill = "_6l-2";